import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import Flex from '@wix/da-ds/pkg/Flex';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';

import s from './WidgetHeader.scss';

export interface Props {
  header?: string | React.ReactNode;
  subHeader?: string;
  count?: number | string;
  className?: string;
  extras?: React.ReactNode | React.ReactNode[];
}

const WidgetHeader: React.FC<Props> = ({ header, subHeader, count, className, extras }) => {
  const hasContent = !!(header || subHeader);
  return (
    <div className={classnames(s['root'], subHeader && s['with-subheader'], className)}>
      {hasContent && (
        <Flex direction="column" gap={4} fullWidth>
          {header && (
            <Heading className={s['header']}>
              {header}
              {!!count && ' '}
              {!!count && <span className={s['count']}>{shortenNumber(count)}</span>}
            </Heading>
          )}
          {subHeader && <div className={s['subheader']}>{subHeader}</div>}
        </Flex>
      )}
      {extras}
    </div>
  );
};
WidgetHeader.displayName = 'WidgetHeader';

export default WidgetHeader;
